// @flow
export const INCREASE_FONT: string = 'INCREASE_FONT'
export const DECREASE_FONT: string = 'DECREASE_FONT'
